<template>
  <div class="press-releases position-relative">
    <h2>{{pressReleases.title}}</h2>
    <div class="d-flex press-releases-desc" v-if="pressReleases.description">
      <span class="press-releases__icon-container">
        <PressReleasesIcon />
      </span>
      <div v-html="pressReleases.description"></div>
    </div>
    <loader-spinner :loading="isLoading" :color="'green'" :size="'30px'" class="position-absolute spinner"></loader-spinner>
    <PressReleaseItem
        v-if="releasesData && releasesData.result.length > 0"
        v-for="release in releasesData.result"
        :data="release"
        :props="pressReleases"
        :key="release.id"
        class=""
    />
<!--     Make a component lol :D -->
    <div
      class="pagination-wrapper py-5 d-flex justify-content-center"
      v-if="releasesData && releasesData.pageCount > 1"
    >
      <paginate
          v-model="releasesData.currentPage"
          :page-count="releasesData.pageCount"
          :page-range="5"
          :margin-pages="3"
          :click-handler="clickCallback"
          prev-text="Previous"
          next-text="Next"
          prev-class="btn-prev"
          next-class="btn-next"
          active-class="btn-active"
      />
    </div>
  </div>
</template>

<script setup>
import {onBeforeMount, ref} from 'vue'
  import PressReleaseItem from "@/components/press-releases/press-release-item";
  import useLoadData from "@/composables/useLoadData";
  import Paginate from 'vuejs-paginate-next';
  import api from "@/config/api";
  import {useRouter} from "vue-router";
  import LoaderSpinner from 'vue-spinner/src/ClipLoader.vue'
  import PressReleasesIcon from '@/assets/icons/press-releases-icon.vue';

  const router = useRouter();
  const page = ref(router.currentRoute.value.query.id || 1)
  const options = ref({method: 'get', params: { page: page.value }});


  const props = defineProps({
    pressReleases: {
      title: String,
      icon: String,
      description: HTMLElement,
      requestUrl: String
    }
  })

  const {data: releasesData, fetchData: fetchPressReleases, isLoading} = useLoadData(api.pressReleases, options.value)

  const clickCallback = (pageNumber) => {
    fetchPressReleases({ params: { page: pageNumber } })
  }

  onBeforeMount(() => {
    fetchPressReleases()
  })

</script>
